export const SCHOOL_BLOG_COUNT = 10;